//配置路由相关信息
import VueRouter from 'vue-router'
import Vue from 'vue'
//import Login from '../components/Login.vue'
//import choose_city from '../choose_city.vue'
//import information from '../information.vue'
//import map from '../map.vue'
//import board from '../board.vue'
//import history from '../history.vue'
//import statistics from '../statistics.vue'
//import package_selection from '../package_selection.vue'
//import package_cost from '../package_cost.vue'
//import package_confirm from '../package_confirm.vue'
//import package_board from '../package_board.vue'
//import package_history from '../package_history.vue'
//import version from '../version.vue'
Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    routes: [{
        path: '/',
        name: 'Login',
        //component: Login,
        component: ()=> import('../components/Login.vue'),
        meta: {
            title: 'Login BAM'
        }
    },
    {
        path: '/activeAccount',
        name: 'activeAccount',
        //component: Login,
        component: ()=> import('../components/activeAccount.vue'),
        meta: {
            title: 'active BAM'
        }
    },
    {
        path: '/en',
        name: 'Login_en',
        //component: Login,
        component: ()=> import('../components/Login.vue'),
        meta: {
            title: 'Login BAM'
        }
    },
    {
        path: '/choose_city',
        name: 'choose_city',
        //component: choose_city,
        component: ()=> import('../choose_city.vue'),
        meta: {
            title: 'Choose City'
        }
    },
    {
        path: '/information',
        name: 'information',
        //component: information,
        component: ()=> import('../information.vue'),
        meta: {
            title: 'information'
        },
    },
    {
        path: '/map',
        //component: map,
        component: ()=> import('../map.vue'),
        meta: {
            title: 'map',
        }
    },
    {
        path: '/process_map',
        //component: map,
        component: ()=> import('../process_map.vue'),
        meta: {
            title: 'process',
        }
    },
    {
        path: '/board',
        name: 'board',
        //component: board,
        component: ()=> import('../board.vue'),
        meta: {
            title: 'board'
        }

    },
    {
        path: '/history',
        name: 'history',
        //component: history,
        component: ()=> import('../history.vue'),
        meta: {
            title: 'history'
        }
    },
    {
        path: '/statistics',
        name: 'statistics',
        //component: statistics,
        component: ()=> import('../statistics.vue'),
        meta: {
            title: 'statistics'
        }
    },
    {
        path: '/statistics_v2',
        name: 'statistics_v2',
        //component: statistics,
        component: ()=> import('../statistics_v2.vue'),
        meta: {
            title: 'statistics_v2'
        }
    },
    {
        path: '/statisticPerson',
        name: 'statisticPerson',
        //component: statistics,
        component: ()=> import('../statisticPerson.vue'),
        meta: {
            title: 'statisticPerson'
        }
    },
    {
        path: '/crossCityPerson',
        name: 'crossCityPerson',
        //component: statistics,
        component: ()=> import('../cross_city_person.vue'),
        meta: {
            title: 'crossCityPerson'
        }
    },
    {
        path: '/usermangement',
        name: 'usermangement',
        //component: usermangement,
        component: ()=> import('../user_mangement.vue'),
        meta: {
            title: 'usermangement'
        }
    },
    {
        path: '/internalusermanagement',
        name: 'internalusermanagement',
        component: ()=> import('../internal_user_management.vue'),
        meta: { title: '内部用户管理' }
    },
    {
        path: '/externalusermanagement',
        name: 'externalusermanagement',
        component: ()=> import('../external_user_management.vue'),
        meta: { title: '外部用户管理' }
    },
    {
        path: '/companymanagement',
        name: 'companymanagement',
        component: ()=> import('../company_management.vue'),
        meta: {
            title: 'company management'
        }
    },
    {
        path: '/package_selection',
        name: 'package_selection',
        //component: package_selection,
        component: ()=> import('../package_selection.vue'),
        meta: {
            title: 'package selection'
        }
    },
    {
        path: '/package_cost',
        name: 'package_cost',
        //component: package_cost,
        component: ()=> import('../package_cost.vue'),
        meta: {
            title: 'package cost'
        }
    },
    {
        path: '/package_confirm',
        name: 'package_confirm',
        //component: package_confirm,
        component: ()=> import('../package_confirm.vue'),
        meta: {
            title: 'package confirm'
        }
    },
    {
        path: '/package_board',
        name: 'package_board',
        //component: package_board,
        component: ()=> import('../package_board.vue'),
        meta: {
            title: 'package board'
        }
    },
    {
        path: '/package_history',
        name: 'package_history',
        //component: package_history,
        component: ()=> import('../package_history.vue'),
        meta: {
            title: 'package history'
        }
    },
    {
        path: '/inventory_history',
        name: 'inventory_history',
        component: ()=> import('../inventory_history.vue'),
        meta: {
            title: 'inventory history'
        }
    },
    {
        path: '/inventory_list',
        name: 'inventory_list',
        component: ()=> import('../inventory_list.vue'),
        meta: {
            title: 'inventory list'
        }
    },
    {
        path: '/choose_city_1',
        name: 'choose_city_1',
        //component: choose_city,
        component: ()=> import('../choose_city_1.vue'),
        meta: {
            title: 'Choose City'
        }
    },
    {
        path: '/cross_city_selection',
        name: 'cross_city_selection',
        component: ()=> import('../cross_city_selection.vue'),
        meta: {
            title: 'cross city selection'
        }
    },
    {
        path: '/cross_city_board',
        name: 'cross_city_board',
        component: ()=> import('../cross_city_board.vue'),
        meta: {
            title: 'cross city board'
        }
    },
    {
        path: '/error',
        name: 'error',
        component: ()=> import('../error.vue'),
        meta: {
            title: 'error'
        }
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'not-found',
        component: ()=> import('../NotFound.vue'),
        meta: {
            title: 'Page Not Found'
        }
    },


    
    ]
});
router.beforeEach((to, from, next) => {
    if (to["name"] != "Login" && to["name"] !="activeAccount" && JSON.parse(sessionStorage.getItem("User")) == null && to["name"] != "not-found" && to["name"] != "error") {
        let lang = JSON.parse(sessionStorage.getItem("lang"));
        sessionStorage.clear()
        sessionStorage.setItem("lang", JSON.stringify(lang))
        router.push({
          path: '/'
        });
    }
    else if (to["name"] == 'choose_city') {
        let lang = JSON.parse(sessionStorage.getItem("lang"));
        let user = JSON.parse(sessionStorage.getItem("User"));
        let authority = JSON.parse(sessionStorage.getItem("UserAuthority"));
        sessionStorage.clear()
        sessionStorage.setItem("lang", JSON.stringify(lang))
        sessionStorage.setItem("User", JSON.stringify(user));
        sessionStorage.setItem("UserAuthority", JSON.stringify(authority));
        next()
    }
    else {
        // 外部用户权限检查
        const userAuthority = JSON.parse(sessionStorage.getItem('UserAuthority'));
        if (userAuthority && userAuthority.is_external_user) {
            const forbiddenRoutes = ['package', 'inventory', 'process', 'statistics'];
            const isForbiddenRoute = forbiddenRoutes.some(route => to.path.includes(route));
            if (isForbiddenRoute) {
                next('/error');
                return;
            }
        }

        if (to.meta.title) {
            document.title = to.meta.title
        }
        
        next()
    }
})




export default router